import { render, staticRenderFns } from "./scrollLoading.vue?vue&type=template&id=b587408e"
import script from "./scrollLoading.vue?vue&type=script&lang=js"
export * from "./scrollLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports